import appdata from '../Services/appdata';
import {
  API_ROOT,
  dispatchGetJSONAsync,
  dispatchPostJSONAsync,
  completeJSONAsync,
} from './BaseApi';

async function login(email, password) {
  const url = `${API_ROOT}/auth/login`;
  let task = await dispatchPostJSONAsync(url, {
    email: email,
    password: btoa(password),
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getSubscriptionStatus() {
  const user_id = appdata.getItem('user').id;
  const company_id = appdata.getItem('company').id;
  const url = `${API_ROOT}/auth/get_subscription`;
  let task = await dispatchPostJSONAsync(url, {
    user_id: user_id,
    company_id: company_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function signup(
  company,
  email,
  password,
  firstName,
  lastName,
  uniqueCode,
  packageId,
  userCurrency,
  customUsers,
) {
  const url = `${API_ROOT}/auth/register`;
  let task = await dispatchPostJSONAsync(url, {
    company: company,
    email: email,
    password: password,
    first_name: firstName,
    last_name: lastName,
    unique_code: uniqueCode,
    package_id: packageId,
    user_currency: userCurrency,
    have_users: customUsers,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function resetSubscription(
  email,
  packageId,
  userCurrency,
  customUsers,
) {
  const url = `${API_ROOT}/auth/reset_subscription`;
  const company = appdata.getItem('company');
  const user = appdata.getItem('user');
  let task = await dispatchPostJSONAsync(url, {
    company_id: company.id,
    user_id: user.id,
    email: email,
    package_id: packageId,
    user_currency: userCurrency,
    have_users: customUsers,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}
async function getUserCompanies(email_or_token, password) {
  const url = `${API_ROOT}/auth/user_companies1/${email_or_token}/${password}`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function sendResetPasswordEmail(email) {
  const url = `${API_ROOT}/auth/reset_password_email`;
  let task = await dispatchPostJSONAsync(url, {
    email: email,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function resetPassword(token, password) {
  const url = `${API_ROOT}/auth/reset_password`;
  let task = await dispatchPostJSONAsync(url, {
    token,
    password,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getRoles() {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/settings/roles/${company.id}`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getUserRole() {
  const company = appdata.getItem('company');
  const user = appdata.getItem('user');
  const url = `${API_ROOT}/settings/roles/${company.id}/user_role/${user.id}`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getCompanyOrg() {
  const company = appdata.getItem('company');
  const user = appdata.getItem('user');
  const url = `${API_ROOT}/settings/companyorg/${company.id}/${user.id}`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function addRole(role_name) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/settings/roles/${company.id}/add`;
  let task = await dispatchPostJSONAsync(url, {
    role_name,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function deleteRole(role_id) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/settings/roles/${company.id}/delete`;
  let task = await dispatchPostJSONAsync(url, {
    role_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updateRole(role_id, role_name, role_accesses) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/settings/roles/${company.id}/update`;
  let task = await dispatchPostJSONAsync(url, {
    role_id,
    role_name,
    role_accesses,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function addUsersToRole(role_id, users) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/settings/roles/${company.id}/add_users`;
  const user_ids = users.map((user) => user.id);
  let task = await dispatchPostJSONAsync(url, {
    role_id,
    user_ids,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function deleteUsersFromRole(role_id, users) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/settings/roles/${company.id}/delete_users`;
  const user_ids = users.map((user) => user.id);
  let task = await dispatchPostJSONAsync(url, {
    role_id,
    user_ids,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function invite(email, role_id, add_billing) {
  const company = appdata.getItem('company');
  const user = appdata.getItem('user');
  const url = `${API_ROOT}/invite`;
  let task = await dispatchPostJSONAsync(url, {
    email,
    company_id: company.id,
    user_id: user.id,
    role_id,
    add_billing,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getInviteInfo(token) {
  const url = `${API_ROOT}/invite/info/token/${token}`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function signupWithInvite(
  company_id,
  email,
  role_id,
  password,
  first_name,
  last_name,
  unique_code,
) {
  const url = `${API_ROOT}/invite/register`;
  let task = await dispatchPostJSONAsync(url, {
    company_id,
    email,
    password,
    first_name,
    last_name,
    role_id,
    unique_code,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

//Company Settings
async function getAllCompanySettings() {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/companysettings/${company.id}`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function addCompanySetting() {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/companysettings/${company.id}/add`;
  let task = await dispatchPostJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function deleteCompanySetting(company_setting_id) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/companysettings/${company.id}/delete`;
  let task = await dispatchPostJSONAsync(url, {
    company_setting_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updateCompanySetting(updated_data) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/companysettings/${company.id}/update`;
  let task = await dispatchPostJSONAsync(url, updated_data);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updateCompanySettingsData(updated_data) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/companysettings/${company.id}/update/data`;
  let task = await dispatchPostJSONAsync(url, {
    updated_data,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function uploadCompanyPhoto(company_id, photoFile, complete) {
  let reader = new FileReader();
  reader.readAsDataURL(photoFile);
  reader.onload = async () => {
    const company = appdata.getItem('company');
    const url = `${API_ROOT}/companysettings/${company.id}/update/logo`;
    let task = await dispatchPostJSONAsync(url, {
      company_id,
      photo_file: reader.result.split(',')[1],
    });
    if (!task) {
      return [];
    }
    let res = await completeJSONAsync(task);
    complete(res);
  };
}

async function getAllCompanyApiKeys(company_org_id) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/companysettings/${company.id}/apikeys/${company_org_id}`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function addCompanyApiKey(company_org_id, apiaccounts) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/companysettings/${company.id}/apikeys/${company_org_id}/add`;
  let task = await dispatchPostJSONAsync(url, {
    apiaccounts,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updateCompanyApiKey(data) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/companysettings/${company.id}/apikeys/update`;
  let task = await dispatchPostJSONAsync(url, data);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getOrganisations(company_org_id) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/companysettings/${company.id}/organisations/${company_org_id}`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updateOrganisationData(updated_data) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/companysettings/${company.id}/organisations/update`;
  let task = await dispatchPostJSONAsync(url, { updated_data });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function addOrganisation(company_org_id, start_month) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/companysettings/${company.id}/organisations/${company_org_id}/add`;
  let task = await dispatchPostJSONAsync(url, { start_month });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function deleteOrganisation(id) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/companysettings/${company.id}/organisations/delete`;
  let task = await dispatchPostJSONAsync(url, { id });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

//Admin
async function getAllCompanies() {
  const url = `${API_ROOT}/admin/companies`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getCompanyUsers(company_id) {
  const url = `${API_ROOT}/admin/company_users/${company_id}`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  let response = await completeJSONAsync(task);

  if (response.status === 200) {
    response.data = response.data
      ? response.data.map((user) => {
          return { ...user, name: `${user.first_name} ${user.last_name}` };
        })
    : [];
  }
  return response;
}

async function deleteUser(company_id, user_id) {
  const url = `${API_ROOT}/admin/delete_user`;
  let task = await dispatchPostJSONAsync(url, {
    company_id,
    user_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function lockUser(company_id, user_id) {
  const url = `${API_ROOT}/admin/lock_user`;
  let task = await dispatchPostJSONAsync(url, {
    company_id,
    user_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function unlockUser(company_id, user_id) {
  const url = `${API_ROOT}/admin/unlock_user`;
  let task = await dispatchPostJSONAsync(url, {
    company_id,
    user_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function resetUserPassword(user_id, new_password) {
  const url = `${API_ROOT}/admin/reset_user_password`;
  let task = await dispatchPostJSONAsync(url, {
    user_id,
    new_password,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updateCompanyOrgId(user_id, company_org_id) {
  const company_id = appdata.getItem('company').company_id;
  const url = `${API_ROOT}/admin/update_company_org_id`;
  let task = await dispatchPostJSONAsync(url, {
    user_id,
    company_id,
    company_org_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function shadowUser(company_id, user_id) {
  const url = `${API_ROOT}/admin/shadow_user`;
  let task = await dispatchPostJSONAsync(url, {
    company_id,
    user_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function userCompanyOrgId() {
  const company_id = appdata.getItem('company').company_id;
  const user_id = appdata.getItem('company').user_id;
  const url = `${API_ROOT}/admin/usercompanyorgid`;
  let task = await dispatchPostJSONAsync(url, {
    company_id,
    user_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function deleteCompany(company_id) {
  const url = `${API_ROOT}/admin/delete_company`;
  let task = await dispatchPostJSONAsync(url, {
    company_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

//Package Management
async function getPackageSettings() {
  const url = `${API_ROOT}/admin/get_package_settings`;
  let task = await dispatchPostJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getPackages() {
  const url = `${API_ROOT}/admin/get_package`;
  let task = await dispatchPostJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function addPackageSetting(package_info) {
  const url = `${API_ROOT}/admin/add_package`;
  let task = await dispatchPostJSONAsync(url, {
    ...package_info,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updatePackageSetting(updated_data) {
  const url = `${API_ROOT}/admin/update_package`;
  let task = await dispatchPostJSONAsync(url, {
    updated_data,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function deletePackage(id) {
  const url = `${API_ROOT}/admin/delete_package`;
  let task = await dispatchPostJSONAsync(url, {
    id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getUserPackage(user_id, company_id) {
  const url = `${API_ROOT}/admin/get_user_package`;
  let task = await dispatchPostJSONAsync(url, {
    user_id,
    company_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getSelectedPackageUsers(package_id) {
  const url = `${API_ROOT}/admin/get_select_package_users`;
  let task = await dispatchPostJSONAsync(url, {
    package_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

//Manage Temp DB
async function getTables() {
  const url = `${API_ROOT}/managetemplate/tables`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  let tables = await completeJSONAsync(task);
  return tables.map((table_name, id) => {
    return {
      id,
      table_name,
    };
  });
}

async function getTableCols(table_name) {
  const url = `${API_ROOT}/managetemplate/cols`;
  let task = await dispatchPostJSONAsync(url, {
    table_name,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getTableRows(table_name) {
  const url = `${API_ROOT}/managetemplate/rows`;
  let task = await dispatchPostJSONAsync(url, {
    table_name,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function addTableRow(table_name) {
  const url = `${API_ROOT}/managetemplate/add_row`;
  let task = await dispatchPostJSONAsync(url, {
    table_name,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function deleteTableRow(table_name, row_id) {
  const url = `${API_ROOT}/managetemplate/delete_row`;
  let task = await dispatchPostJSONAsync(url, {
    table_name,
    row_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function addTableCol(table_name, col_name, col_type) {
  const url = `${API_ROOT}/managetemplate/add_col`;
  let task = await dispatchPostJSONAsync(url, {
    table_name,
    col_name,
    col_type,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updateTableData(table_name, updated_data) {
  const url = `${API_ROOT}/managetemplate/update_data`;
  let task = await dispatchPostJSONAsync(url, {
    table_name,
    updated_data,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updatePackage(updatePackageId, newPlanID, customUsers) {
  const user_id = appdata.getItem('user').id;
  const company_id = appdata.getItem('company').id;
  const url = `${API_ROOT}/auth/update_package`;
  let task = await dispatchPostJSONAsync(url, {
    user_id,
    company_id,
    updatePackageId,
    newPlanID,
    customUsers,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function cancelSubscription() {
  const company_id = appdata.getItem('company').id;
  const url = `${API_ROOT}/auth/cancel_subscription`;
  let task = await dispatchPostJSONAsync(url, {
    company_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

const DefaultApi = {
  API_ROOT,
  login,
  getSubscriptionStatus,
  signup,
  getUserCompanies,
  sendResetPasswordEmail,
  resetPassword,
  getRoles,
  getCompanyOrg,
  getUserRole,
  addRole,
  deleteRole,
  updateRole,
  addUsersToRole,
  deleteUsersFromRole,
  invite,
  getInviteInfo,
  signupWithInvite,

  getAllCompanySettings,
  addCompanySetting,
  deleteCompanySetting,
  updateCompanySetting,
  updateCompanySettingsData,
  uploadCompanyPhoto,
  getAllCompanyApiKeys,
  addCompanyApiKey,
  updateCompanyApiKey,
  getOrganisations,
  updateOrganisationData,
  addOrganisation,
  deleteOrganisation,

  getAllCompanies,
  getCompanyUsers,

  deleteUser,
  lockUser,
  unlockUser,
  resetUserPassword,
  updateCompanyOrgId,
  shadowUser,
  userCompanyOrgId,

  deleteCompany,

  getTables,
  getTableCols,
  getTableRows,
  addTableCol,
  addTableRow,
  updateTableData,
  deleteTableRow,

  getPackageSettings,
  getPackages,
  addPackageSetting,
  updatePackageSetting,
  deletePackage,
  getUserPackage,
  getSelectedPackageUsers,

  updatePackage,
  cancelSubscription,
  resetSubscription,
};

export default DefaultApi;
